module.exports = __webpack_public_path__ + "assets/img/close.c478b938.png";